import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 2H2V22H11V17H13V22H22V2H13V7H11V2ZM17.1823 10.2321L15.4146 11.9999L17.1823 13.7676L15.7681 15.1818L12.5861 11.9999L15.7681 8.81787L17.1823 10.2321ZM8.33023 8.81825L11.5122 12.0002L8.33023 15.1822L6.91602 13.768L8.68378 12.0002L6.91602 10.2325L8.33023 8.81825Z"}}]};

const MergeCellsFilled = Vue.extend<IconProps>({
  name: 'MergeCellsFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'merge-cells-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MergeCellsFilled;
